/**
 * Local TS shapes for the dynamic `metadata.extractions.<kind>` blob
 * that the BE writes onto DocRefs after a domain extractor runs (per
 * the GDN-1032 follow-up handoff). Not in the OpenAPI spec yet — keep
 * these in sync if the BE ever publishes them.
 */

import type { DocumentReferenceMetadata } from '@store/generated/document-references';

export interface ExtractionStamp {
  /** Null until the user has acted on the extraction. ISO 8601. */
  acted_on_at?: string | null;
  /** Auth0 user id of whoever saved it. */
  acted_on_by?: string | null;
  /** 0–100 confidence from the extractor. */
  confidence?: number | null;
}

export interface InsuranceCardExtraction extends ExtractionStamp {
  payer_name?: string | null;
  member_id?: string | null;
  group_number?: string | null;
  plan_name?: string | null;
  subscriber_first_name?: string | null;
  subscriber_last_name?: string | null;
  /** `self` | `spouse` | `child` | `other` */
  subscriber_relationship?: string | null;
  effective_date?: string | null;
}

/** Wider shape used to access `extractions` since the codegen'd
 *  `DocumentReferenceMetadata` models it only as a nested record. */
type MetadataWithExtractions = Omit<DocumentReferenceMetadata, 'extractions'> & {
  extractions?: {
    insurance_card?: InsuranceCardExtraction;
    [kind: string]: unknown;
  };
};

/**
 * Pull the insurance-card extraction off a DocRef metadata blob, if
 * present and not yet acted on. Returns `null` for any of:
 *   - no metadata
 *   - extraction missing
 *   - already acted on (banner should not render)
 */
export function pickActionableInsuranceCard(
  metadata: DocumentReferenceMetadata | undefined | null,
): InsuranceCardExtraction | null {
  const wider = metadata as MetadataWithExtractions | undefined | null;
  const card = wider?.extractions?.insurance_card;
  if (!card) return null;
  if (card.acted_on_at) return null;
  return card;
}
